<template>
  <div id="app" class="app" :class=classObject>
<!--    <Sidebar @click='isOpen = !isOpen'/> -->
    <Main @click='MobMenuIsOpen = !MobMenuIsOpen'/>
<!--    <Popup /> -->
  </div>
</template>

<script>
//  import Sidebar from '@/components/Sidebar'
  import Main from '@/components/Main'
//  import Popup from '@/components/Popup'
  export default {
    name: 'main-layout',
    data: () => ({
      isOpen: false,
      MobMenuIsOpen: false
    }),
    computed: {
      classObject: function () {
//        test = (!MobMenuIsOpen ? 'off' : '')
//        if (!this.MobMenuIsOpen)
//          test = 'off'
//        else
//          test = ''
//        return  (!this.MobMenuIsOpen ? 'off ' : '') + (this.isOpen ? 'full' : 'small')
          return 'off '+'small'
      }
    },
    components: {
//      Sidebar, Main, Popup
      Main
    }
  }
</script>

<style lang='sass' scoped>
  @import '@/assets/sass/_main.sass'
  @import '@/assets/sass/_sidebar.sass'
  @import '@/assets/sass/_header.sass'
  @import '@/assets/sass/_footer.sass'
  @import '@/assets/sass/_tabs.sass'
  @import '@/assets/sass/_forms.sass'
  @import '@/assets/sass/_logout.sass'
  @import '@/assets/sass/_client_popup.sass'
  @import '@/assets/sass/_lxc_popup.sass'
  @import '@/assets/sass/_datepicker_popup.sass'
  @import '@/assets/sass/_popup.sass'
  @import '@/assets/sass/_media.sass'
</style>
